import {
    GET_COURSE_COMPONENTS_FAIL,
    GET_COURSE_COMPONENTS_SUCCESS,
    ADD_COURSE_COMPONENT_SUCCESS,
    ADD_COURSE_COMPONENT_FAIL,
    UPDATE_COURSE_COMPONENT_SUCCESS,
    UPDATE_COURSE_COMPONENT_FAIL,
    DELETE_COURSE_COMPONENT_SUCCESS,
    DELETE_COURSE_COMPONENT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    courseComponents: [],
    error: null,
    loading: true,
    lastActionSuccess: false
};

const courseComponentReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des subjects
        case GET_COURSE_COMPONENTS_SUCCESS:
            return {
                ...state,
                courseComponents: action.payload, // tableau d'objets subject
                loading: false,
                error: null
            };

        case GET_COURSE_COMPONENTS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une subjecte
        case ADD_COURSE_COMPONENT_SUCCESS:
            return {
                ...state,
                courseComponents: [action.payload, ...state.courseComponents], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_COURSE_COMPONENT_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'une subjecte
        case UPDATE_COURSE_COMPONENT_SUCCESS:
            return {
                ...state,
                courseComponents: state.courseComponents.map(courseComponent =>
                    courseComponent.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet subject
                        : courseComponent
                ),
                error: null,
                lastActionSuccess: true
            };

        case UPDATE_COURSE_COMPONENT_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'une subjecte
        case DELETE_COURSE_COMPONENT_SUCCESS:
            return {
                ...state,
                courseComponents: state.courseComponents.filter(
                    courseComponent => courseComponent.id !== action.payload
                ),
                error: null
            };


        case DELETE_COURSE_COMPONENT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        default:
            return state;
    }
};

export default courseComponentReducer;
